import React from 'react';
import { Image } from 'react-bootstrap';
import ConsultationImg from '../Images/Consultation Banner.png';
import './Nutrition.css';

function Consultation() {
  return (
    <div className="bg-page">
      <Image src={ConsultationImg} fluid className="Banner-Img" />

      <div className="form-section">
        <div className="form-wrapper">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSddPkWqMpdSZMS68e2mGGpjT-PZmJdbincT3Cj3DjCiVOt7Gg/viewform?embedded=true"
            className="google-form"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Nutrition Form"
          >
            Loading...
          </iframe>
        </div>
      </div>
    </div>
  );
}

export default Consultation;